import PropTypes from 'prop-types' // eslint-disable-line no-unused-vars
import { PureComponent } from 'react'
import { autobind } from 'core-decorators'
import imageUtils from 'shared/util/image-utils'
import css from './background.css'

// Animation settings
const ANIMATION_SETTINGS = {
    minSpeed: 2,
    maxSpeed: 5,
    maxItems: 7,
}

// Set random asset properties
let assetProps = (images, isUpdate) => {
    const img = images[0]
    images.push(images.shift())
    return {
        x: Math.random() * window.innerWidth,
        y: window.innerHeight + (isUpdate ? 0 : Math.random() * window.innerHeight),
        speed:
            ANIMATION_SETTINGS.minSpeed + Math.random() * (ANIMATION_SETTINGS.maxSpeed - ANIMATION_SETTINGS.minSpeed),
        img: img,
    }
}

/**
 * Animated Background: Animated background which accepts an image
 * asset and floats it around all nice-like.
 *
 * @class AnimatedBackground
 * @param {String} assetUrl Image url to use for background assets.
 */
export default class AnimatedBackground extends PureComponent {
    static propTypes = {
        assetUrls: PropTypes.array,
    }

    // elements
    canvas = null
    canvasContext = null

    // vars
    assets = []
    drawInterval = null
    items = []

    /**
     * Triggered when the item image asset is loaded.
     *
     * @param {Image} img Item image element.
     */
    @autobind
    __assetImageLoaded(imgs) {
        this.assets = imgs

        // setup items
        for (var i = 0; i < ANIMATION_SETTINGS.maxItems; i++) {
            var item = assetProps(this.assets)
            this.items.push(item)
        }

        // start animating
        this.startAnimating()
    }

    /**
     * Draw and move the background item elements to canvas.
     *
     */
    @autobind
    _draw() {
        if (!this.canvas || !this.canvasContext) return

        // reset canvas
        this.canvasContext.clearRect(0, 0, this.canvas.width, this.canvas.height)
        this.canvas.width = window.innerWidth
        this.canvas.height = window.innerHeight

        this.canvas.style.webkitTransform = 'rotate(' + this.rotateX + 'deg)'

        // draw items!
        for (let i = 0; i < this.items.length; i++) {
            let item = this.items[i]
            let scale = item.speed / ANIMATION_SETTINGS.maxSpeed
            let width = item.img.naturalWidth / scale
            let height = item.img.naturalHeight / scale

            this.canvasContext.drawImage(item.img, item.x - width / 2, item.y, width, height)

            item.y -= item.speed

            if (item.y < -height) {
                this.items[i] = assetProps(this.assets, true)
            }
        }
    }

    /**
     * Set variables and start drawing background animation.
     *
     */
    componentDidMount() {
        if (!this.props.assetUrls) return

        this.canvasContext = this.canvas.getContext('2d')

        // preload image asset
        imageUtils.preloadImage(this.props.assetUrls).then(this.__assetImageLoaded)
    }

    componentWillUnmount() {
        this.stopAnimating()
    }

    /**
     * Start animating the background.
     */
    startAnimating() {
        this.stopAnimating()
        this.drawInterval = setInterval(this._draw, 30)
    }

    /**
     * Stop animating the background.
     */
    stopAnimating() {
        clearInterval(this.drawInterval)
    }

    /**
     * Render the container div and canvas elements.
     *
     */
    render() {
        return (
            <div className={css.animatedBackground} ref={c => (this.el = c)}>
                <canvas ref={c => (this.canvas = c)} />
            </div>
        )
    }
}
